// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Select_hidden__2tVIP {\n  display: none;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Select/Select.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hidden": "Select_hidden__2tVIP"
};
export default ___CSS_LOADER_EXPORT___;
